/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RefreshButton from './ui/RefreshButton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Switch } from './ui/switch';
import {
  Coins, Package, Gift, Clock, Zap, Users, TrendingUp, TrendingDown,
  Plus, Edit, Trash2, Eye, Search, Filter, Download, RefreshCw,
  UserPlus, Cake, Award, ShoppingCart, FileText, Key, AlertTriangle,
  CheckCircle, XCircle, Calendar, Timer, Percent, Hash, ArrowUpRight,
  ArrowDownRight, BarChart3, PieChart, Activity, Settings, Star, CreditCard,
  HelpCircle, BookOpen
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import StripeCheckoutButton from './StripeCheckoutButton';
import Sparkline from './credits/Sparkline';
import CreditUsagePlansTab from './CreditUsagePlansTab';
import CreditStatsAdvancedTab from './CreditStatsAdvancedTab';
import CreditAlertsAdminTab from './CreditAlertsAdminTab';


export const GCPacksTab = ({ ctx }) => {
  const {
    actions, activeTab, attributeForm, attributeSearch, bonusForm, bonusRules,
    bulkAttributeForm, creditTypes, duplicateRaison, duplicateSource, duplicateTargetSearch,
    duplicateTargetUserId, editForm, editTarget, editingBonus, editingPack, loading,
    packForm, packs, searchTerm, selectedUserIds, showAttributeModal, showBonusModal,
    showBulkAttributeModal, showDuplicateModal, showEditModal, showPackModal, sparkSeries, stats,
    transactions, userBalances,
    setActions, setActiveTab, setAttributeForm, setAttributeSearch, setBonusForm, setBonusRules,
    setBulkAttributeForm, setCreditTypes, setDuplicateRaison, setDuplicateSource, setDuplicateTargetSearch,
    setDuplicateTargetUserId, setEditForm, setEditTarget, setEditingBonus, setEditingPack,
    setLoading, setPackForm, setPacks, setSearchTerm, setSelectedUserIds, setShowAttributeModal,
    setShowBonusModal, setShowBulkAttributeModal, setShowDuplicateModal, setShowEditModal, setShowPackModal,
    setSparkSeries, setStats, setTransactions, setUserBalances,
    exportUsersCsv, filteredUsers, handleAttributeCredits, handleBulkAttribute, handleBulkDelete,
    handleConfirmDuplicate, handleDeletePack, handleDeleteUserCredits, handleExportFiltered,
    handleExportSelection, handleSaveBonus, handleSaveEdit, handleSavePack, loadData, openDuplicateModal,
    openEditModal, renderIcon, resetPackForm, toggleSelectAllFiltered, toggleUserSelection,
    getAuthHeader, CountdownWidget, StatsCard, COLORS, AVAILABLE_ICONS,
  } = ctx;
  return (
        <TabsContent value="packs" className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {packs.map((pack) => {
              const totalCredits = pack.credits_inclus + (pack.credits_bonus || 0);
              const IconComponent = AVAILABLE_ICONS.find(i => i.name === pack.icone)?.icon || Package;
              
              return (
                <Card key={pack.id} className={`relative overflow-hidden ${pack.populaire ? 'ring-2 ring-amber-500' : ''}`}>
                  {pack.populaire && (
                    <div className="absolute top-0 right-0 bg-amber-500 text-white text-xs px-3 py-1 rounded-bl-lg font-medium">
                      ⭐ Populaire
                    </div>
                  )}
                  <CardHeader style={{ backgroundColor: `${pack.couleur}10` }}>
                    <div className="flex items-center gap-3">
                      <div className="p-3 rounded-xl" style={{ backgroundColor: pack.couleur }}>
                        <IconComponent className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <CardTitle>{pack.nom}</CardTitle>
                        <CardDescription>{pack.description}</CardDescription>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent className="pt-4">
                    <div className="text-center mb-4">
                      <div className="text-4xl font-bold" style={{ color: pack.couleur }}>
                        {totalCredits}
                      </div>
                      <div className="text-gray-500">crédits</div>
                      {pack.credits_bonus > 0 && (
                        <Badge className="mt-2 bg-green-600 text-white font-semibold">
                          <Gift className="w-3 h-3 mr-1" />
                          +{pack.credits_bonus} bonus
                        </Badge>
                      )}
                    </div>
                    
                    <div className="border-t pt-4">
                      <div className="flex justify-between items-baseline mb-2">
                        <span className="text-2xl font-bold">{pack.prix_ttc?.toFixed(2)} €</span>
                        <span className="text-sm text-gray-500">Global</span>
                      </div>
                      <div className="text-sm text-gray-500 mb-4">
                        {(pack.prix_ht / pack.credits_inclus).toFixed(2)} € / crédit
                      </div>
                      
                      <div className="flex gap-2">
                        <Button 
                          variant="outline" 
                          size="sm" 
                          className="flex-1"
                          onClick={() => {
                            setEditingPack(pack);
                            setPackForm({
                              nom: pack.nom,
                              description: pack.description,
                              credits_inclus: pack.credits_inclus,
                              credits_bonus: pack.credits_bonus || 0,
                              bonus_pourcentage: pack.bonus_pourcentage || 0,
                              prix_ht: pack.prix_ht,
                              type_credit: pack.type_credit,
                              icone: pack.icone,
                              couleur: pack.couleur,
                              populaire: pack.populaire,
                              ordre_affichage: pack.ordre_affichage || 0
                            });
                            setShowPackModal(true);
                          }}
                        >
                          <Edit className="w-4 h-4" />
                        </Button>
                        <Button 
                          variant="outline" 
                          size="sm" 
                          className="text-red-600 hover:bg-red-50"
                          onClick={() => handleDeletePack(pack.id)}
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                      {/* Bouton Acheter avec Stripe */}
                      <StripeCheckoutButton
                        type="credits"
                        item={pack}
                        getAuthHeader={getAuthHeader}
                        buttonText="Acheter ce pack"
                        buttonVariant="default"
                        className="w-full mt-2 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600"
                      />
                    </div>
                  </CardContent>
                </Card>
              );
            })}
            
            {/* Carte pour ajouter un nouveau pack */}
            <Card 
              className="border-dashed border-2 cursor-pointer hover:border-amber-500 hover:bg-amber-50 transition-colors"
              onClick={() => { resetPackForm(); setEditingPack(null); setShowPackModal(true); }}
            >
              <CardContent className="h-full flex flex-col items-center justify-center py-12">
                <Plus className="w-12 h-12 text-gray-400 mb-4" />
                <p className="text-gray-500 font-medium">Créer un nouveau pack</p>
              </CardContent>
            </Card>
          </div>
        </TabsContent>
  );
};

export default GCPacksTab;
